<template>
    <div>
        <breadcrumbs :text="personLabel" :company="company" />
        <person-form
            :person-data="person"
            :departments="departments"
            :custom-roles="['DRIVER', 'GUIDE', 'MANAGER']"
            :role-prefix="''"
            :dont-allow-edit="company?.type === 'HUB_SUPPLIER'"
            :redirect="!person.personId"
        />
        <passport-modal @saved="refresh" />
    </div>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import PersonForm from '~src/components/account/forms/personForm.src'
    import {CompanyPersonPage} from '~/pages/account/CompanyPersonPage.vue'

    @Component({
        components: {
            PersonForm,
        },
    })
    export class SupplierPersonPage extends CompanyPersonPage {}

    export default SupplierPersonPage
</script>
